import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hero-line_85bbe7c98558800ce2fbc85c1e150c2d",
  "use": "hero-line_85bbe7c98558800ce2fbc85c1e150c2d-usage",
  "viewBox": "0 0 1440 71",
  "content": "<symbol viewBox=\"0 0 1440 71\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"hero-line_85bbe7c98558800ce2fbc85c1e150c2d\">\n<path opacity=\"0.5\" d=\"M0 68.5431L34.6896 55.5578C208.816 -9.62243 399.38 -16.5938 577.803 35.6891C709.997 74.4257 849.564 80.8272 984.749 54.3546L1111.44 29.5449C1222.34 7.82766 1337.26 21.4682 1440 68.5431\" stroke=\"#55586B\" stroke-dasharray=\"6 6\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol